export default function (data) {
	return JSON.parse(JSON.stringify(data));
}
